import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';

export function SuggestedSubset() {
  // TODO: Implement suggested subsets logic
  return (
    <div>
      <h2 className="mb-2 font-serif text-base font-semibold text-gray-900">Suggested Subsets</h2>
      <div className="space-y-2">
        <div className="rounded-md border border-gray-200 bg-white p-3">
          <div className="flex items-center justify-between">
            <div className="mb-1 flex items-center gap-1.5">
              <Icon className="lucide--sparkles text-sm text-blue-600" />
              <h3 className="text-sm font-medium text-gray-900">Key Documents</h3>
            </div>
            <Button size="sm">
              <Icon className="lucide--plus" />
              Create subset
            </Button>
          </div>

          <p className="text-xs text-gray-600">Create a subset of 24 key documents.</p>
        </div>
        <div className="rounded-md border border-gray-200 bg-white p-3">
          <div className="flex items-center justify-between">
            <div className="mb-1 flex items-center gap-1.5">
              <Icon className="lucide--sparkles text-sm text-purple-600" />
              <h3 className="text-sm font-medium text-gray-900">Deposition Transcripts</h3>
            </div>

            <Button size="sm">
              <Icon className="lucide--plus" />
              Create subset
            </Button>
          </div>

          <p className="text-xs text-gray-600">Create a subset of 16 deposition transcripts.</p>
        </div>

        <div className="rounded-md border border-gray-200 bg-white p-3">
          <div className="flex items-center justify-between">
            <div className="mb-1 flex items-center gap-1.5">
              <Icon className="lucide--sparkles text-sm text-blue-600" />
              <h3 className="text-sm font-medium text-gray-900">Recently Uploaded Documents</h3>
            </div>
            <Button size="sm">
              <Icon className="lucide--plus" />
              Create subset
            </Button>
          </div>

          <p className="text-xs text-gray-600">Create a subset from the 8 documents you uploaded yesterday.</p>
        </div>
      </div>
    </div>
  );
}
